export class ChatMessage {
  id: string;
  content: string;
  sender: 'user' | 'bot' | 'action' | 'response';
  origin: string = null;
  response = false;

  constructor(
    id: string,
    content: string,
    sender: 'user' | 'bot' | 'action' | 'response'
  ) {
    this.id = id;
    this.content = content;
    this.sender = sender;
  }
}
